var _style, _defs, _polygon, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#XMLID_2_);fill:url(#XMLID_3_);}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.48;}\n\t.st2{fill:#6D6E71;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.288;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_76_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_141_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    d: "M101.2,248.7c0-86.4,70.1-156.5,156.5-156.5c86.4,0,156.5,70.1,156.5,156.5 c0,86.4-70.1,156.5-156.5,156.5C171.2,405.2,101.2,335.2,101.2,248.7 M81.1,248.7c0,97.5,79.1,176.6,176.6,176.6 c97.5,0,176.6-79.1,176.6-176.6c0-97.5-79-176.6-176.6-176.6C160.2,72.1,81.1,151.2,81.1,248.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_142_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.8744,
    y1: 678.634,
    x2: -45.3978,
    y2: 678.634,
    gradientTransform: "matrix(-55.7868 -55.7868 -55.7868 55.7868 35459.0352 -40267.5586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4961,
    style: {
      stopColor: "#EFF8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62BB46"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_74_",
    className: "st0",
    points: "257.7,601.9 -95.5,248.7 257.7,-104.5 610.9,248.7  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st1",
    d: "M101.2,248.7c0-86.4,70.1-156.5,156.5-156.5c86.4,0,156.5,70.1,156.5,156.5 c0,86.4-70.1,156.5-156.5,156.5C171.2,405.2,101.2,335.2,101.2,248.7z M434.3,248.7c0,97.5-79,176.6-176.6,176.6 c-97.5,0-176.6-79.1-176.6-176.6c0-97.5,79.1-176.6,176.6-176.6C355.2,72.1,434.3,151.2,434.3,248.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_69_",
    className: "st2",
    points: "274.4,224.6 287.6,224.6 263.7,255.4 263.7,271.8 252.4,271.8 252.4,255.4  228.4,224.6 241.7,224.6 258,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_68_",
    className: "st3",
    points: "274.4,224.6 287.6,224.6 263.7,255.4 263.7,271.8 252.4,271.8 252.4,255.4  228.4,224.6 241.7,224.6 258,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_67_",
    className: "st2",
    points: "337.9,224.6 337.9,234.2 306.2,234.2 306.2,243.2 336.6,243.2 336.6,252.5  306.2,252.5 306.2,262.2 337.9,262.2 337.9,271.8 295.1,271.8 295.1,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_66_",
    className: "st3",
    points: "337.9,224.6 337.9,234.2 306.2,234.2 306.2,243.2 336.6,243.2 336.6,252.5  306.2,252.5 306.2,262.2 337.9,262.2 337.9,271.8 295.1,271.8 295.1,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_65_",
    className: "st2",
    points: "279.4,283.8 279.4,293.4 247.6,293.4 247.6,302.4 278.1,302.4 278.1,311.7  247.6,311.7 247.6,321.4 279.4,321.4 279.4,331.1 236.6,331.1 236.6,283.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_64_",
    className: "st3",
    points: "279.4,283.8 279.4,293.4 247.6,293.4 247.6,302.4 278.1,302.4 278.1,311.7  247.6,311.7 247.6,321.4 279.4,321.4 279.4,331.1 236.6,331.1 236.6,283.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st2",
    d: "M374.7,253.8h-9v18h-11v-47.3h28.7c8.1,0,14.6,6.6,14.6,14.7c0,6.7-4.4,12.3-10.5,14 l13.9,18.6h-13.2L374.7,253.8z M382.4,234.2h-16.6v10.3h16.6c2.8,0,5.1-2.5,5.1-5.1C387.5,236.8,385.3,234.2,382.4,234.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st3",
    d: "M374.7,253.8h-9v18h-11v-47.3h28.7c8.1,0,14.6,6.6,14.6,14.7c0,6.7-4.4,12.3-10.5,14 l13.9,18.6h-13.2L374.7,253.8z M382.4,234.2h-16.6v10.3h16.6c2.8,0,5.1-2.5,5.1-5.1C387.5,236.8,385.3,234.2,382.4,234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st2",
    d: "M272.3,359.4c0-2.6-2.1-5.2-5.1-5.2h-19.4v10.4h19.4C270.1,364.6,272.3,362,272.3,359.4  M236.7,391.9v-47.3h31.6c8,0,14.5,6.6,14.5,14.7c0,6.1-3.8,11.4-9.1,13.6l14.2,19.1h-13.2l-13.5-18h-13.5v18H236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    className: "st3",
    d: "M272.3,359.4c0-2.6-2.1-5.2-5.1-5.2h-19.4v10.4h19.4C270.1,364.6,272.3,362,272.3,359.4z  M236.7,391.9v-47.3h31.6c8,0,14.5,6.6,14.5,14.7c0,6.1-3.8,11.4-9.1,13.6l14.2,19.1h-13.2l-13.5-18h-13.5v18H236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    className: "st2",
    d: "M231.8,271.8h-11.9l-3.9-8.2h-26.7l-3.9,8.2h-11.8l23.6-47.3h11L231.8,271.8z M202.7,235.8 l-9.4,18.7h18.6L202.7,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st3",
    d: "M231.8,271.8h-11.9l-3.9-8.2h-26.7l-3.9,8.2h-11.8l23.6-47.3h11L231.8,271.8z M202.7,235.8 l-9.4,18.7h18.6L202.7,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    className: "st2",
    d: "M287.2,211.6h-11.9l-3.9-8.2h-26.7l-3.9,8.2h-11.8l23.6-47.3h11L287.2,211.6z M258,175.5 l-9.4,18.7h18.6L258,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st3",
    d: "M287.2,211.6h-11.9l-3.9-8.2h-26.7l-3.9,8.2h-11.8l23.6-47.3h11L287.2,211.6z M258,175.5 l-9.4,18.7h18.6L258,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st2",
    d: "M128.1,243.4h20c2.3,0,4.5-2,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-20V243.4z M128.1,262.4H149 c3,0,5.4-2.5,5.4-5.2c0-2.6-2.5-5.4-5.4-5.4h-20.9V262.4z M160.1,247.2c2.8,2.6,5.1,5.8,5.1,10.3c0,7.9-6.3,14.4-15.3,14.4h-32.7 v-47.3l32.4,0c7.6,0,13.8,6.2,13.8,13.8C163.3,241.7,162.1,244.8,160.1,247.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st3",
    d: "M128.1,243.4h20c2.3,0,4.5-2,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-20V243.4z M128.1,262.4H149 c3,0,5.4-2.5,5.4-5.2c0-2.6-2.5-5.4-5.4-5.4h-20.9V262.4z M160.1,247.2c2.8,2.6,5.1,5.8,5.1,10.3c0,7.9-6.3,14.4-15.3,14.4h-32.7 v-47.3l32.4,0c7.6,0,13.8,6.2,13.8,13.8C163.3,241.7,162.1,244.8,160.1,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st2",
    d: "M247.7,125.2h19.9c2.3,0,4.5-2,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-19.9V125.2z M247.7,144.3h20.9 c3,0,5.4-2.5,5.4-5.2c0-2.6-2.5-5.4-5.4-5.4h-20.9V144.3z M279.5,129.1c2.8,2.6,5.1,5.8,5.1,10.3c0,7.9-6.3,14.4-15.3,14.4h-32.7 v-47.3l32.4,0c7.6,0,13.8,6.2,13.8,13.8C282.8,123.6,281.5,126.7,279.5,129.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st3",
    d: "M247.7,125.2h19.9c2.3,0,4.5-2,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-19.9V125.2z M247.7,144.3h20.9 c3,0,5.4-2.5,5.4-5.2c0-2.6-2.5-5.4-5.4-5.4h-20.9V144.3z M279.5,129.1c2.8,2.6,5.1,5.8,5.1,10.3c0,7.9-6.3,14.4-15.3,14.4h-32.7 v-47.3l32.4,0c7.6,0,13.8,6.2,13.8,13.8C282.8,123.6,281.5,126.7,279.5,129.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBayer);
export default __webpack_public_path__ + "static/media/bayer.045d3c6e03179989728f1d4d1149cad2.svg";
export { ForwardRef as ReactComponent };